<template>
    <date-range-picker
        ref="picker"
        v-model="dateRange"
        :ranges="ranges"
        :show-dropdowns="true"
        :control-container-class="controlContainerClass"
        :opens="opens"
        :disabled="disabled"
        @select="selectRange"
    >
        <template #ranges="picker">
            <div class="ranges">
                <ul>
                    <li v-for="(range, name) in picker.ranges" :key="name" @click="picker.clickRange(range); predefRange();">
                        <b>{{ name }}</b>
                    </li>
                </ul>
            </div>
        </template>
        <template #input="picker">
            <template v-if="label">{{ label }}</template>
            <template v-else>
                {{ picker.startDate | moment(format) }} - {{ picker.endDate | moment(format) }}
            </template>
        </template>
        <template #footer="picker">
            <div class="drp-footer">
                <div class="inputs">
                    <input :value="dateRange.startDate | moment(format)" :placeholder="format" ref="inputStartDate" @change="inputRange"> To <input :value="dateRange.endDate | moment(format)" :placeholder="format" ref="inputEndDate" @change="inputRange">
                </div>
                <div class="buttons">
                    <button type="button" @click="picker.clickCancel(); clearRange();">Clear</button>
                    <button type="button" @click="picker.clickApply(); applyRange();" :disabled="picker.in_selection" class="btn-apply">Apply</button>
                </div>
            </div>
        </template>
    </date-range-picker>
</template>
<script>
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import moment from 'moment'

export default {
    components: {
        DateRangePicker
    },
    props: {
      controlContainerClass: {
        type: String,
        default: 'form-control'
      },
      label: {
        type: String
      },
      opens: {
        type: String,
        default: 'center'
      },
      format: {
        type: String,
        default: 'YYYY/MM/DD'
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data() {
        return {
            dateRange: {
                startDate: moment().toDate(),
                endDate: moment().toDate()
            },
            ranges: {
                'Last Week': [moment().subtract(1, 'week').toDate(), moment().toDate()],
                'Last Month': [moment().subtract(1, 'month').toDate(), moment().toDate()],
                'Last 3 Months': [moment().subtract(3, 'month').toDate(), moment().toDate()]
            }
        }
    },
    methods: {
        selectRange(range) {
            this.dateRange = range
            this.$refs.picker.togglePicker(false)
            this.$emit('select', this.dateRange)
        },
        inputRange() {
            let start = this.$refs['inputStartDate'].value
            let end = this.$refs['inputEndDate'].value

            if(moment(start, this.format).isValid() && moment(end, this.format).isValid()) {
                this.dateRange.startDate = moment(start, this.format).toDate()
                this.dateRange.endDate = moment(end, this.format).toDate()
            } else {
                this.$refs['inputStartDate'].value = moment(this.dateRange.startDate).format(this.format)
                this.$refs['inputEndDate'].value = moment(this.dateRange.endDate).format(this.format)
            }
            this.$emit('select', this.dateRange)
        },
        predefRange() {
            this.$refs.picker.togglePicker(false)
        },
        applyRange() {
            this.$emit('select', this.dateRange)
        },
        clearRange() {
            let today = new Date()
            this.dateRange = {
                startDate: today,
                endDate: today
            }
            this.$emit('clear')
        }
    }
}
</script>
<style lang="scss" scoped>
.vue-daterange-picker::v-deep {
    width: 100%;
}
.drp-footer {
    display: flex;
    align-items: center;
    font-size: 12px;
    padding: 0.5em;
    border-top: 1px solid #ddd;
    .inputs {
        margin-left: 140px;
    }
    .buttons {
        flex: 1 0 auto;
        text-align: right;
        button {
            margin-left: 0.5em;
        }
    }
    input {
        text-align: center;
        width: 100px;
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 0.5em;
    }
    button {
        background: #fff;
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 0.5em 1em;
        &.btn-apply {
            background: #00A82D;
            color: #fff;
            &:hover {
                color: #000;
            }
        }
        &:hover {
            background: #ddd;
        }
    }
}
@media (max-width: 768px) {
    .vue-daterange-picker::v-deep {
        .calendars-container {
            display: block;
        }
        .drp-footer {
            display: block;
            text-align: center;
            .inputs {
                margin-left: 0;
            }
            .buttons {
                text-align: center;
                margin-top: 0.5em;
            }
        }
    }
}
</style>
